// ExpenseBudgetItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import currency from '../../../lib/currency.jsx'
import Checkbox from '../../../common/form/checkbox/checkbox.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import DateUtil from '../../../lib/dateutil.jsx'

class ExpenseBudgetItem extends Component {
  constructor (props) {
    super(props)

    this.data = {
      suppliers: [],
      showExpand: false
    }
  }

  static get propTypes () {
    return {
      expenseItem: PropTypes.object,
      selectable: PropTypes.bool,
      onDelete: PropTypes.func,
      onToggleSelect: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      expenseItem: null,
      selectable: true,
      onDelete: null,
      onToggleSelect: null
    }
  }

  render () {
    const expenseItem = this.props.expenseItem
    const budgetItem = expenseItem.budgetItem || {}
    const selectable = this.props.selectable
    const _className = `expense-budgetitem${
      selectable ? '' : ' expense-budgetitem_alt'
    }`
    const purchaseOrder = expenseItem.purchaseOrder || null
    const suppliers = expenseItem.suppliers || []
    const hasSubContent = suppliers.length > 0

    return (
      <div className={_className}>
        <div className='maincont'>
          <div className='budgetcol title'>
            <div className='name'>{budgetItem.title || '-'}</div>
            <div className='infolist'>
              <div className='infoitem'>
                <span className='label'>
                  <IntlMessage ident='expense.form.labelInfoProject' />
                </span>
                <span className='value'>
                  {expenseItem.project ? ` ${expenseItem.project.title}` : '-'}
                </span>
              </div>
              <div className='infoitem'>
                <span className='label'>
                  <IntlMessage ident='expense.form.labelClient' />
                </span>
                <span className='value'>
                  {expenseItem.project && expenseItem.project.contact
                    ? ` ${expenseItem.project.contact.company}`
                    : '-'}
                </span>
              </div>
            </div>
            {purchaseOrder && purchaseOrder.invoiceNo && (
              <div className='poinfo'>
                <div className='invoicebtn'>{purchaseOrder.invoiceNo}</div>
                <div className='infoitem'>
                  <span className='label'>
                    <IntlMessage ident='expense.form.labelPoAmt' />
                  </span>
                  <span className='value'>
                    <PriceText value={expenseItem.openPoAmount} />
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className='budgetcol unit'>
            {budgetItem.bUseTotal ? (
              <IntlMessage ident='expense.form.budgetNotAvailable' />
            ) : (
              <span>
                {currency.format(budgetItem.noHours)}
                <IntlMessage ident='expense.form.unit' />
              </span>
            )}
          </div>
          <div className='budgetcol rate'>
            {budgetItem.bUseTotal ? (
              <IntlMessage ident='expense.form.budgetNotAvailable' />
            ) : (
              <span>
                <PriceText value={budgetItem.pricePerHour} />
                <IntlMessage ident='expense.form.rate' />
              </span>
            )}
          </div>
          <div className='budgetcol budget'>
            <PriceText value={budgetItem.total} />
          </div>
          <div className='budgetcol spent'>
            <PriceText value={budgetItem.spentAmount} />
          </div>
          <div className='itemcheck'>
            <Checkbox
              checked={expenseItem.selected}
              icon='budget'
              onChange={this._onChecked.bind(this)}
            />
          </div>
          {hasSubContent && (
            <span
              className='itemaccordion'
              onClick={this._onToggleExpand.bind(this)}
            >
              {this.data.showExpand ? (
                <i className='icon icon-planner-accordionclose' />
              ) : (
                <i className='icon icon-grid-expand normal' />
              )}
            </span>
          )}
        </div>
        {this.data.showExpand && hasSubContent && (
          <div className='subcont'>
            {suppliers.map((supplier, supplierIdx) => (
              <div className='budgetsupplierrow' key={supplierIdx}>
                <div className='title'>{supplier.title}</div>
                <div className='budgetexpenselist'>
                  {supplier.expenses.map((expense, expenseIdx) => (
                    <div className='budgetexpenseitem' key={expenseIdx}>
                      <div className='expensecol date'>
                        {DateUtil.getDisplayDate(expense.invoiceDate)}
                      </div>
                      <div className='expensecol'>
                        <span className='invoicebtn'>{expense.invoiceNo}</span>
                      </div>
                      <div className='expensecol total'>
                        <PriceText value={expense.total} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }

  /* Event Handlers */
  _onChecked (value) {
    this.props.expenseItem.selected = value
    if (this.props.onToggleSelect) {
      this.props.onToggleSelect(this.props.expenseItem, value)
    }
  }

  _onDelete (ev) {
    ev.preventDefault()

    if (this.props.onDelete) {
      this.props.onDelete(this.props.expenseItem)
    }
  }

  _onToggleExpand (ev) {
    ev.preventDefault()

    this.data.showExpand = !this.data.showExpand
    this.setState({ dataDate: new Date() })
  }
}

export default ExpenseBudgetItem
